<template>
  <div id="info-hover-box" @mouseover="hoverInfo = true" @mouseleave="hoverInfo = false">
    <span @mouseover="hoverInfo = true" @mouseleave="hoverInfo = false" class="hover-element">
      <slot name="icon" style="position:relative;"></slot>
    </span>
    
    <div class="hover-content" :class="{'left': left, 'right': right, 'top': top, 'mid' : mid, 'mid-x' : midX, 'no-padding': noPadding, 'auto-width' : autoWidth, 'hover-info': hoverInfo }" :style="{ 'min-width': minWidth + 'px', 'max-width': maxWidth + 'px', 'width': width + 'px'}">
      <slot></slot>
    </div> 

  </div>
</template>
<script>
export default {
    name: 'infobox',
    props: {
      disabled: { type: Boolean, default: false },
      EventBus: { type: Object },
      text: { type: String, required: false, default: 'Toggle' },
      minWidth: { type: [Number, String] },
      maxWidth: { type: [Number, String] },
      width: { type: [Number, String] },
      conditionalToggle: { type: Boolean, default: true },
      left: Boolean,
      right: Boolean,
      top: Boolean,
      mid: Boolean,
      midX: Boolean,
      noPadding: Boolean,
      autoWidth: Boolean,
      tabIndex: { type: Number, default: 100 },
      isOpen: { type: Boolean, default: false },
    },
  data() {
    return {
        hoverInfo: false
    };
  }
}
</script>

<style lang="less">
#info-hover-box{
    display: inline-block;
    position: relative;

    // .hover-element{
      
      // }
    .hover-content{
        // display: none;
        box-shadow: 2px 4px 4px 2px rgba(0, 0, 0, 0.25);
        background: var(--background-white);
        position: absolute;
        pointer-events: none;
        padding: 12px;
        z-index: 9999;
        transition-delay: .2s ;
        transition: .3s;
        opacity: 0;
        border-radius: var(--standard-border-radius);

          &.no-padding{
            padding:4px 12px;
          }
       
        ul{
            list-style-type: none;
            margin: 0;
            padding-left: 10px;
            li{
                margin-bottom: 4px;
                    font-weight: 400;
            }
                span{
                    font-weight: 600;
                }
            a{
                pointer-events: auto;
            }
        }  
        
    &.left {
        right: 100%;
        left: unset;
        text-align: left;
      }

      &.right {
        left: 100%;
        // right: 0;
      }
      &.mid{     
        left: 50%;
        transform: translateX(-50%);
      }
      &.mid-x{
        top: 50%;
        transform: translateY(-50%);
      }
      &.top {
          bottom: 50%;
          // top: 0
      }
      &.bottom {
          top: 100%;
          // bottom: 0
      }
      
      &.auto-width{
        width: auto;
      }

    }
    .hover-info{
        // display: block;
        transition-delay: .2s;
        opacity: 1;
   
    }

}
</style>
